export function convertFromVCF (vcf: string, callback: (err: Error | null, data: any) => void) {
  const worker = new Worker(new URL('./vcard-parser-worker.js', import.meta.url), { type: 'module' });
  worker.postMessage(vcf);

  worker.onmessage = (e) => {
    callback(null, e.data);
  }

  worker.onerror = (e) => {
    callback(e.message, null);
  }
}
